"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "attendeeCameraRemoved", {
  enumerable: true,
  get: function get() {
    return _attendeeCameraRemoved["default"];
  }
});
var _attendeeCameraRemoved = _interopRequireDefault(require("./attendeeCameraRemoved"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }